export default {
  data() {
    return {
      errorModal: false,
      errorModalData: {},
      errorModalLoading: false,
      errorModalCallback: () => null,
      customTitle: null,
    }
  },
  methods: {
    onErrorModalCallback() {
      this.errorModalLoading = true
      this.errorModalCallback()
    },
    onErrorModalClose() {
      this.resetErrorModal()
    },
    setErrorModal(data, callback, title = null) {
      if (typeof callback != 'function') {
        callback = () => null
      }
      this.errorModal = true
      this.errorModalData = data || {}
      this.errorModalLoading = false
      this.errorModalCallback = callback
      this.customTitle = title
    },
    resetErrorModal() {
      this.errorModal = false
      this.errorModalData = {}
      this.errorModalLoading = false
      this.errorModalCallback = () => null
      this.customTitle = null
    },
    generateReportTitleAndData(error) {
      if (error.AnalyteGuidelineUnitMismatchExceptionRecord || error.AnalyteLabResultUnitMismatchExceptionRecord) { 
        // If exception data confront the expect data structure
        return { data: error, customTitle: null }
      } else if (typeof(error) == 'string') { 
        // If exception data is just a string
        let customTitle = this.$t('WaterQualityReportErrorModal.unexpectedErrorMsg', { message: `: ${error}`})
        return { data: [error], customTitle }
      } else { 
        // If the exception data could not be interpreted.
        let customTitle = this.$t('WaterQualityReportErrorModal.unexpectedErrorMsg', { message: ''})
        return { data: [], customTitle }
      }
    },
  },
}
